"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printSummaryRangeTranslations = {
    "en": {
        for: "for",
        report: "Report",
        dateRange: "Date Range:",
        timeZone: "Timezone:",
        historicalReport: "Historical Report",
        activeReport: "Active Report",
    },
    "de": {
        for: "für",
        report: "Bericht",
        dateRange: "Zeit Raum:",
        timeZone: "ZeitZone:",
        historicalReport: "Historischer Bericht",
        activeReport: "Aktiver Bericht",
    },
    "nl": {
        for: "voor",
        report: "Rapport",
        dateRange: "Datumbereik:",
        timeZone: "Tijdzone:",
        historicalReport: "Historisch rapport",
        activeReport: "Actief rapport",
    },
    "it": {
        for: "per",
        report: "Rapporto",
        dateRange: "Date Range:",
        timeZone: "Timezone:",
        historicalReport: "Statistiche storico",
        activeReport: "Statistiche correnti",
    },
    "fr": {
        for: "pour",
        report: "Rapport",
        dateRange: "Plage Dates:",
        timeZone: "FuseauHoraire:",
        historicalReport: "Rapport historique",
        activeReport: "Rapport actif",
    },
    "es": {
        for: "para",
        report: "Informe",
        dateRange: "Intervalo de fechas:",
        timeZone: "Zona horaria:",
        historicalReport: "Informe histórico",
        activeReport: "Informe activo",
    },
    "ja": {
        for: "対象",
        report: "報告書",
        dateRange: "データ範囲:",
        timeZone: "タイムゾーン:",
        historicalReport: "履歴レポート",
        activeReport: "アクティブレポート",
    },
    "en-GB": {
        for: "for",
        report: "Report",
        dateRange: "Date Range:",
        timeZone: "Timezone:",
        historicalReport: "Historical Report",
        activeReport: "Active Report",
    },
    "ru": {
        for: "для",
        report: "Отчет",
        dateRange: "Временной Интервал:",
        timeZone: "Таймзона:",
        historicalReport: "Активный Отчет",
        activeReport: "Выбрать агента",
    },
};
